import React, { useEffect, useRef, useState } from "react";
import {
  ChevronDownIcon,
  DocumentDownloadIcon,
} from "@heroicons/react/outline";
import { downloadBulkTemplate } from "../../utils/referralBulkUpload";

export default function TemplateDownloadButton({ config }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const download = (format) => {
    downloadBulkTemplate({
      baseName: config.templateBaseName,
      columns: config.columns,
      sampleRow: config.sampleRow,
      format,
    });
    setOpen(false);
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 border border-gray-300 rounded-md"
      >
        <DocumentDownloadIcon className="w-4 mr-1.5" />
        Template
        <ChevronDownIcon className="w-3 ml-1" />
      </button>
      {open && (
        <div className="absolute right-0 z-20 mt-2 w-44 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
          <div className="py-1">
            <button
              type="button"
              onClick={() => download("csv")}
              className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
            >
              CSV template
            </button>
            <button
              type="button"
              onClick={() => download("xlsx")}
              className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
            >
              Excel template
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
